import { useEffect, useRef, useState } from 'react';

export function useDebouncedState(value, delay) {
    const [debounced, setDebounced] = useState(value);
    const timer = useRef<ReturnType<typeof setTimeout> | null>(null);

    useEffect(() => {
        clearTimeout(timer.current);
        timer.current = setTimeout(() => setDebounced(value), delay);
        // value тут завжди останнє
        // debounce завжди підтягує актуальне
        return () => clearTimeout(timer.current);
    }, [value, delay]);

    return debounced;
}
